// @flow

/* eslint-disable camelcase */
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import messages from '../../../messages';
import Select from '../../../../common/forms/Select';
import SelectMinMax from '../../../../common/forms/SelectMinMax';
import SelectFrom from '../../../../common/forms/SelectFrom';
import withConfig from '../../../../hoc/WithConfig';
import Form from '../shared/Form/component';
import styles from './styles';

type Props = {
  hideFilters: Function,
  setFilter: Function,
  setType: Function,
  setSort: Function,
  showing: boolean,
  isFetching: boolean,
  animated: boolean,
  count: number,
  onClearFilters: Function,
  filtersValues: Object,
  sortValues: Object,
  filters: Object,
  sort: string,
  intl: IntlShape,
};

const {
  sortByTitle,
  filtersCities,
  filtersRegions,
  filtersDate,
  filtersCityArea,
  filtersTo,
  filtersNoMax,
  filtersNoMin,
  filtersAny,
  filtersSalary,
  filtersJobCategory,
  filtersCompany,
  filtersJobType,
  filtersWorkingHours,
  filtersExperience,
} = messages;

const Filters = (props: Props) => {
  const {
    hideFilters,
    showing,
    count,
    onClearFilters,
    isFetching,
    animated,
    filtersValues,
    sortValues,
    filters,
    sort,
    setFilter,
    setSort,
    intl,
  } = props;

  return (
    <Form
      intl={intl}
      showing={showing}
      hideFilters={hideFilters}
      onClearFilters={onClearFilters}
      count={count}
      isFetching={isFetching}
      animated={animated}
    >
      <div className="row">
        <label htmlFor="sort">
          <FormattedMessage {...sortByTitle} />
        </label>
        <Select name="sort" onChange={setSort} selectedOption={sort} options={sortValues} />
      </div>

      <div className="row">
        <label htmlFor="dateFrom">
          <FormattedMessage {...filtersDate} />
        </label>
        <Select
          name="date_from"
          onChange={setFilter}
          selectedOption={filters.date_from}
          markAsActive={filters.date_from}
          options={filtersValues.date_from}
        />
      </div>

      <div className="row">
        <label htmlFor="salaryMin">
          <FormattedMessage {...filtersSalary} />
        </label>
        <SelectMinMax
          minOptions={filtersValues.salary_min}
          minName="salary_min"
          minOnChange={setFilter}
          minSelectedOption={filters.salary_min}
          minPlaceholder={intl.formatMessage(filtersNoMin)}
          maxOptions={filtersValues.salary_max}
          maxName="salary_max"
          maxOnChange={setFilter}
          maxSelectedOption={filters.salary_max}
          maxPlaceholder={intl.formatMessage(filtersNoMax)}
          toString={intl.formatMessage(filtersTo)}
        />
      </div>

      <div className="row">
        <label htmlFor="jobCategory">
          <FormattedMessage {...filtersJobCategory} />
        </label>
        <Select
          name="category"
          onChange={setFilter}
          selectedOption={filters.category}
          markAsActive={filters.category}
          options={filtersValues.category}
        />
      </div>

      <div className="row">
        <label htmlFor="company">
          <FormattedMessage {...filtersCompany} />
        </label>
        <Select
          name="company"
          onChange={setFilter}
          selectedOption={filters.company}
          markAsActive={filters.company}
          options={filtersValues.company}
        />
      </div>

      <div className="row">
        <div className="columns">
          <div className="column half">
            <label htmlFor="job_type">
              <FormattedMessage {...filtersJobType} />
            </label>
            <Select
              name="job_type"
              onChange={setFilter}
              selectedOption={filters.job_type}
              markAsActive={filters.job_type}
              options={filtersValues.job_type}
            />
          </div>
          <div className="column half">
            <label htmlFor="workingHours">
              <FormattedMessage {...filtersWorkingHours} />
            </label>
            <Select
              name="working_hours"
              onChange={setFilter}
              selectedOption={filters.working_hours}
              markAsActive={filters.working_hours}
              options={filtersValues.working_hours}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <label htmlFor="experienceMin">
          <FormattedMessage {...filtersExperience} />
        </label>
        <SelectFrom
          onChange={setFilter}
          name="experience_min"
          selectedOption={filters.experience_min}
        />
      </div>

      {filtersValues.region && (
        <div className="row">
          <label htmlFor="region">
            <FormattedMessage {...filtersRegions} />
          </label>
          <Select
            name="region"
            onChange={setFilter}
            options={filtersValues.region}
            selectedOption={filters.region}
            markAsActive={filters.region}
            placeholder={intl.formatMessage(filtersAny)}
          />
        </div>
      )}

      {filtersValues.city && (
        <div className="row">
          <label htmlFor="city">
            <FormattedMessage {...filtersCities} />
          </label>
          <Select
            name="city"
            onChange={setFilter}
            options={filtersValues.city}
            selectedOption={filters.city}
            markAsActive={filters.city}
            placeholder={intl.formatMessage(filtersAny)}
          />
        </div>
      )}

      {filters.region && filters.city && filtersValues.city_area && (
        <div className="row">
          <label htmlFor="cityArea">
            <FormattedMessage {...filtersCityArea} />
          </label>
          <Select
            name="city_area"
            onChange={setFilter}
            options={filtersValues.city_area}
            selectedOption={filters.city_area}
            markAsActive={filters.city_area}
            placeholder={intl.formatMessage(filtersAny)}
          />
        </div>
      )}
      <style jsx>{styles}</style>
    </Form>
  );
};

export default injectIntl(withConfig(Filters));



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/jobs/component.js